import { put, call } from 'redux-saga/effects';
import { FailedUrlsAction, UIAction } from '../actions';
import { FailedUrlsService } from '../services';
import { generateReadableError } from 'hooks';

export function* getFailedUrls(action) {

  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  yield put(FailedUrlsAction.failedUrlsSuccess(null));
  try {
    const { data } = yield call(FailedUrlsService.getInstance().fetchFailedUrls, action.payload);
    yield put(FailedUrlsAction.failedUrlsSuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}


export function* getFailedUrlsFrequency(action) {

  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  yield put(FailedUrlsAction.failedUrlsFrequencySuccess(null));
  try {
    const { data } = yield call(FailedUrlsService.getInstance().fetchFailedUrlsFrequency, action.payload);
    yield put(FailedUrlsAction.failedUrlsFrequencySuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}






